import React from "react"

type ResultItemProps = {
  title: string
  path: string
  index: number
}

export const ResultItem = ({ title, path, index }: ResultItemProps) => {
  return (
    <li
      className="border-b border-black-20"
      role="option"
      id={`suggestion-${index}`}
    >
      <a
        href={path}
        className="flex items-center outline-none transition-colors duration-100 focus:outline-dark hover:bg-purple-100 hover:text-purple-400"
      >
        <span className="text-14 truncate px-12 py-16">
          {title}
        </span>
      </a>
    </li>
  )
}
